"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const arrowStyles = ({
  variant
}) => ({
  backgroundColor: variant === 'dark' ? 'secondary.default' : 'white'
});
var _default = exports.default = arrowStyles;